import u from "./_defineProperty.js";
function i(r, e, t) {
  e == "__proto__" && u ? u(r, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : r[e] = t;
}
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseAssignValue.js
// module id = 440
// module chunks = 41